'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { cn } from '@/lib/utils'

const bottomNavItems = [
  { href: '/dashboard', label: 'Accueil', icon: '⊞' },
  { href: '/sales', label: 'Ventes', icon: '🧾' },
  { href: '/clients', label: 'Clients', icon: '👥' },
  { href: '/stock', label: 'Stock', icon: '📦' },
  { href: '/cash', label: 'Caisse', icon: '💰' },
]

export function BottomNav() {
  const pathname = usePathname()

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 border-t bg-card md:hidden safe-area-inset-bottom">
      <div className="flex h-16">
        {bottomNavItems.map(({ href, label, icon }) => {
          const active = pathname === href || pathname.startsWith(href + '/')
          return (
            <Link
              key={href}
              href={href}
              className={cn(
                'flex flex-1 flex-col items-center justify-center gap-0.5 text-xs transition-colors',
                active ? 'text-primary font-semibold' : 'text-muted-foreground',
              )}
            >
              <span className="text-xl leading-none">{icon}</span>
              <span>{label}</span>
            </Link>
          )
        })}
      </div>
    </nav>
  )
}
